import React from 'react';
import { getSupabaseClient } from '../supabaseClient';
import { useNavigate, Link } from 'react-router-dom';
import { ROUTES } from '../config/routes';
import './Login.css';
import bifLogo from '../assets/shiriki-logo.png';

export default function Login() {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const navigate = useNavigate();
  const supabase = getSupabaseClient();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;

      if (data.user) {
        // Check if user has admin privileges
        const { data: userData, error: roleError } = await supabase
          .from('users')
          .select('role')
          .eq('email', data.user.email)
          .single();

        if (roleError) {
          throw new Error('Failed to verify admin privileges');
        }

        if (userData.role !== 'admin' && userData.role !== 'superadmin') {
          throw new Error('Access denied: Admin privileges required');
        }

        // Successfully authenticated as admin
        navigate(ROUTES.DASHBOARD);
      }
    } catch (error) {
      setError(error instanceof Error ? error.message : 'An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={bifLogo} alt="Shiriki" className="login-logo" />
        <div className="login-header">
          <h2>Admin Login</h2>
          <p className="login-subtitle">Access restricted to authorized personnel only</p>
        </div>
        <form onSubmit={handleLogin}>
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@example.com"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>
          <button type="submit" disabled={loading} className="login-button">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div className="login-footer">
          <Link to={ROUTES.LANDING} className="back-link">
            ← Back to Landing Page
          </Link>
          <p className="security-notice">
            This is a secure admin portal. Unauthorized access is prohibited.
          </p>
        </div>
      </div>
    </div>
  );
}